var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatrixText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.08333 -1.74845e-07L3.25 0L3.25 1L1.08333 1L1.08333 -1.74845e-07Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75008 -1.74845e-07L11.9167 0L11.9167 1L9.75008 1L9.75008 -1.74845e-07Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8.19408e-05 12L-8.14199e-05 -4.00688e-08L1.08325 0L1.08325 12L-8.19408e-05 12Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.08333 11L3.25 11L3.25 12L1.08333 12L1.08333 11Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75008 11L11.9167 11L11.9167 12L9.75008 12L9.75008 11Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9167 12L11.9167 -4.37114e-08L13 0L13 12L11.9167 12Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23877 2.16113H3.90221V3.69662H2.23877V2.16113Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23877 5.23242H3.90221V6.76791H2.23877V5.23242Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23877 8.30273H3.90221V9.83822H2.23877V8.30273Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70435 2.16113H7.36779V3.69662H5.70435V2.16113Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70435 5.23242H7.36779V6.76791H5.70435V5.23242Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70435 8.30273H7.36779V9.83822H5.70435V8.30273Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16992 2.16113H10.8334V3.69662H9.16992V2.16113Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16992 5.23242H10.8334V6.76791H9.16992V5.23242Z",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16992 8.30273H10.8334V9.83822H9.16992V8.30273Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrixText);
export default __webpack_public_path__ + "static/media/matrix-text.d49a7d92ea95900ca387c1de12831358.svg";
export { ForwardRef as ReactComponent };